import React from 'react'
import {MATCHDAY, NMB, PRE} from '../../../../../constants/identifiers';
import {calculateTimeDifference} from '../../../../../helpers/helperFunctions';
import {getMarketByCode} from './marketHelpers';
import {
    BOTH_TEAMS_SCORE,
    CORRECT_SCORE,
    HANDICAP_FIRST,
    HANDICAP_SECOND,
    TOTAL_GOALS,
    UNDER_OVER_15,
    UNDER_OVER_25,
    UNDER_OVER_35,
    WIN_DRAW_WIN
} from '../../matchday/constants/marketTypes';
import {MATCHDAY_MODULE_TYPE} from '../constants/identifiers';
import {getText} from '../../../../../helpers/localization';
import {countDecimals, roundNumber} from '../../../../../helpers/mathFunctions';
import {OPERATOR} from '../../../../../constants/operator';

export function isMatchDay(eventType) {
    switch (eventType) {
        case MATCHDAY:
            return true;
        default:
            return false;
    }
}


export function isMatchdayNMB(storeData) {
    let matchdayNMB = false;
    let selectedGame = storeData.vpp.games[storeData.vpp.selectedGameIndex];
    let selectedMatchday = storeData.vpp.events[storeData.vpp.selectedEventIndex];

    for (let i = 0; i < storeData.vpp.noMoreBetsEventList.length; i++) {
        if (selectedGame.type === MATCHDAY_MODULE_TYPE && selectedMatchday !== undefined && selectedMatchday[0] !== undefined
            && storeData.vpp.noMoreBetsEventList[i].eventId === selectedMatchday[0].eventId && storeData.vpp.noMoreBetsEventList[i].gameChannel === selectedGame.channel
            && selectedGame.controllerState !== undefined && (selectedGame.controllerState[1] === PRE || selectedGame.controllerState[1] === NMB)) {
            matchdayNMB = true;
            break;
        }
    }
    return matchdayNMB;
}

export function isMatchdayPRE(game) {
    return Array.from(Object.values(game.controllerState)).includes(PRE);
}

export function getLiveScore(eventId, eventTime, game, serverTimeOffset, objectRequired) {

    let timeDiff = calculateTimeDifference(eventTime, new Date(Date.now() - serverTimeOffset));

    //Added 8sec delay to find eventGoals since the video starts 7sec late.
    let selectedEventGoals = game.goalTimings !== undefined ? game.goalTimings.filter(goalTiming => parseInt(goalTiming.eventID, 10) === parseInt(eventId, 10)
                                && parseInt(goalTiming.timeMs, 10) < (parseInt(timeDiff, 10) - 7000)) : undefined;
    if (selectedEventGoals === undefined || selectedEventGoals.length < 1)
        //this is to handle 1 minute Matchday games.
        return getLiveScoreFromGoalTimingsHistory(eventId, eventTime, game, serverTimeOffset, objectRequired);
    else
        return objectRequired ? selectedEventGoals[selectedEventGoals.length - 1] : selectedEventGoals[selectedEventGoals.length - 1].score;
}

export function getLiveScoreFromGoalTimingsHistory(eventId, eventTime, game, serverTimeOffset, objectRequired) {

    let timeDiff = calculateTimeDifference(eventTime, new Date(Date.now() - serverTimeOffset));

    //Added 8sec delay to find eventGoals since the video starts 7sec late.
    let selectedEventGoals = game.historicGoalTimings !== undefined ? game.historicGoalTimings.filter(goalTiming => parseInt(goalTiming.eventID, 10) === parseInt(eventId, 10)
                                && parseInt(goalTiming.timeMs, 10) < (parseInt(timeDiff, 10) - 7000)) : undefined;
    if (selectedEventGoals === undefined || selectedEventGoals.length < 1)
        return objectRequired ? undefined : '0-0';
    else
        return objectRequired ? selectedEventGoals[selectedEventGoals.length - 1] : selectedEventGoals[selectedEventGoals.length - 1].score;
}

export function getFinalScore(eventId, game, objectRequired) {

    let selectedEventGoals = game.goalTimings !== undefined ? game.goalTimings.filter(goalTiming => parseInt(goalTiming.eventID, 10) === parseInt(eventId, 10)) : undefined;
    if (selectedEventGoals === undefined || selectedEventGoals.length < 1)
        return objectRequired ? undefined : '0-0';
    else
        return objectRequired ? selectedEventGoals[selectedEventGoals.length - 1] : selectedEventGoals[selectedEventGoals.length - 1].score;
}

export function isWinningBet(bet, game, serverTimeOffset) {

    let market = getMarketByCode(bet.Market.Code);
    let selection;
    if (bet.OpaqueData !== undefined && bet.OpaqueData !== '') {
        let marketDetails = JSON.parse(bet.OpaqueData);
        selection = marketDetails.selection;
    }

    let score = getLiveScore(bet.EventId, bet.EventTime, game, serverTimeOffset);

    let scoreSplit = score.split('-');
    let homeGoal = parseInt(scoreSplit[0], 10);
    let awayGoal = parseInt(scoreSplit[1], 10);
    let result;
    switch (market) {
        case WIN_DRAW_WIN:
            if (selection.toLowerCase() === 'draw')
                result = homeGoal === awayGoal ? true : false;
            else if (selection.toLowerCase() === 'matchday_' + bet.EventDetails.team1.toLowerCase())
                result = homeGoal > awayGoal ? true : false;
            else if (selection.toLowerCase() === 'matchday_' + bet.EventDetails.team2.toLowerCase())
                result = homeGoal < awayGoal ? true : false;
            break;

        case BOTH_TEAMS_SCORE:
            if (selection.toLowerCase() === 'both score yes')
                result = homeGoal > 0 && awayGoal > 0 ? true : false;
            else
                result = homeGoal < 1 || awayGoal < 1 ? true : false;
            break;

        case UNDER_OVER_15:
            if (selection.toLowerCase() === 'over 1.5')
                result = homeGoal + awayGoal > 1.5 ? true : false;
            else
                result = homeGoal + awayGoal < 1.5 ? true : false;
            break;

        case UNDER_OVER_25:
            if (selection.toLowerCase() === 'over 2.5')
                result = homeGoal + awayGoal > 2.5 ? true : false;
            else
                result = homeGoal + awayGoal < 2.5 ? true : false;
            break;

        case UNDER_OVER_35:
            if (selection.toLowerCase() === 'over 3.5')
                result = homeGoal + awayGoal > 3.5 ? true : false;
            else
                result = homeGoal + awayGoal < 3.5 ? true : false;
            break;

        case TOTAL_GOALS:
            result = homeGoal + awayGoal === parseInt(selection, 10) ? true : false;
            break;

        case CORRECT_SCORE:
            result = score === selection ? true : false;
            break;

        case HANDICAP_FIRST:
            homeGoal++;
            if (selection.toLowerCase() === 'draw')
                result = homeGoal === awayGoal ? true : false;
            else if (selection.toLowerCase() === 'matchday_' + bet.EventDetails.team1.toLowerCase())
                result = homeGoal > awayGoal ? true : false;
            else if (selection.toLowerCase() === 'matchday_' + bet.EventDetails.team2.toLowerCase())
                result = homeGoal < awayGoal ? true : false;
            break;

        case HANDICAP_SECOND:
            awayGoal++;
            if (selection.toLowerCase() === 'draw')
                result = homeGoal === awayGoal ? true : false;
            else if (selection.toLowerCase() === 'matchday_' + bet.EventDetails.team1.toLowerCase())
                result = homeGoal > awayGoal ? true : false;
            else if (selection.toLowerCase() === 'matchday_' + bet.EventDetails.team2.toLowerCase())
                result = homeGoal < awayGoal ? true : false;
            break;

        default:
            result = false;
    }

    return result;
}

export function isSingleBetOrPartOfAccaBet(bet, openBetsList) {

    let accaBet = openBetsList.filter((oBet) => oBet.bets.length > 1 &&
        oBet.bets[0].event.channel === bet.event.channel && oBet.bets[0].event.leagueDay === bet.event.leagueDay);

    if (accaBet.length === 0)
        return true;

    let betsOnSameEvent = openBetsList.filter((oBet) => oBet.bets.length === 1
        && oBet.bets[0].event.channel === bet.event.channel && oBet.bets[0].event.eventId === bet.event.eventId);

    if (betsOnSameEvent !== undefined && betsOnSameEvent.length === 1)
        return true;
    else
        return false;

}

export function getAccaBetName(bets, store) {
    switch (bets) {
        case 2:
            return getText("Doubles", store);
        case 3:
            return getText("Trebles", store);
        case 4:
            return getText("Four Folds", store);
        case 5:
            return getText("Five Folds", store);
        case 6:
            return getText("Six Folds", store);
        case 7:
            return getText("Seven Folds", store);
        case 8:
            return getText("Eight Folds", store);
        default:
            return ''
    }
}


export function getPotentialReturn(odds, stake, multiplier, bonusPercentage,promoValue=0) {
    let currentStake, oddsDecimals, stakeDecimals, bonusDecimals, potentialReturns, bonus = 0;
    stakeDecimals = Math.pow(10, countDecimals(stake));
    oddsDecimals = Math.pow(10, countDecimals(odds));
    odds = parseFloat(parseFloat(odds) * oddsDecimals).toFixed(0);
    currentStake = parseFloat(parseFloat(stake) * stakeDecimals).toFixed(0);
    potentialReturns = currentStake * odds * Number(multiplier ? multiplier : 1);
    potentialReturns = roundNumber(potentialReturns / (oddsDecimals * stakeDecimals), 2);
    potentialReturns = potentialReturns.toFixed(2);
    let pReturnDecimals = Math.pow(10, countDecimals(potentialReturns));
    if (bonusPercentage && bonusPercentage !== 0) {
        bonusDecimals = Math.pow(10, countDecimals(bonusPercentage));
        bonusPercentage = (parseFloat(bonusPercentage) * bonusDecimals).toFixed(0);
        bonus = Number(((potentialReturns * pReturnDecimals).toFixed(0) * bonusPercentage) / 100);
        bonus = roundNumber((bonus / (bonusDecimals)), 2);
    }
    bonusDecimals = Math.pow(10, countDecimals(bonus));
    potentialReturns = (potentialReturns * pReturnDecimals).toFixed(0);
    let result = parseFloat((potentialReturns * bonusDecimals) + (bonus * bonusDecimals)).toFixed(0);
    return roundNumber((result / (pReturnDecimals * bonusDecimals) ) - promoValue, 2);
}

export function getRoundedOdds(bets, isOpenBet) {
    if (bets.length == 1) {
        return isOpenBet ? bets[0].market.odds : bets[0].Market.Price;
    } else {
        let decimals, decimalsAccumulator, oddsSum;
        decimalsAccumulator = 1;
        oddsSum = bets.map(function (bet) {
            decimals = Math.pow(10, countDecimals(isOpenBet ? bet.market.odds : bet.Market.Price));
            decimalsAccumulator = decimalsAccumulator * decimals;
            return parseFloat((Number(isOpenBet ? bet.market.odds : bet.Market.Price) * decimals)).toFixed(0);
        }).reduce((a, b) => a * b);
        return roundNumber(oddsSum / decimalsAccumulator, 2);
    }
}

export function getBonusPercentage(store, key) {
    let bonusPercentage ;
    if(key != undefined && key != null){
        bonusPercentage = OPERATOR.accaBoostBonusEnabled ? JSON.parse(OPERATOR.accaBoostBonusPercentage)[key] : 0;
    }else{
        bonusPercentage = OPERATOR.accaBoostBonusEnabled ? JSON.parse(OPERATOR.accaBoostBonusPercentage)[8] : 0;
    }
    let bonusTextPrefix = getText('+', store) + getText('Bonus_Info', store, [bonusPercentage]).trim();
    return (bonusPercentage === 0 || bonusPercentage === undefined) ? null : bonusTextPrefix;
}

export function isTextBasedGame(channel){
    let textBased = false;
    let textBasedEventFlag = JSON.parse(OPERATOR.showTextBasedEvents)[channel];
    if(textBasedEventFlag != undefined){
        textBased = textBasedEventFlag !== 0;
    }
    return textBased;
}


// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/matchday/helpers/matchdayHelper.js